import SectionFive from "./HomeSections/SectionFive";
// import SectionFour from "./HomeSections/SectionFour";
import SectionJoin from "./HomeSections/SectionJoin";
import SectionOne from "./HomeSections/SectionOne";
import SectionThree from "./HomeSections/SectionThree";
import SectionTwo from "./HomeSections/SectionTwo";

export default function Home () {
    return (
        <div>
            <SectionOne />
            <SectionJoin />
            <SectionTwo />
            <SectionThree />
            {/* <SectionFour /> */}
            <SectionFive />
        </div>
    )
}